export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/tax-refund.e63cac9e-5f317d.png";